import { __awaiter as r, __generator as o, __spreadArray as e } from "tslib";
import t from "lodash/isEmpty";
import i from "lodash/merge";

var n = function n(_n, s, m, a) {
  return r(void 0, void 0, void 0, function () {
    var r, l;
    return o(this, function (o) {
      switch (o.label) {
        case 0:
          return [4, Promise.all(a.map(function (r) {
            return r(_n, s, m);
          }))];

        case 1:
          return r = o.sent(), l = i.apply(void 0, e([{}], r, !1)), t(l) ? [2, Promise.resolve()] : [2, Promise.reject(l)];
      }
    });
  });
};

export { n as runValidators };